export default {
	passwordConfirmation: {
		// Security Section
		securityVerification: 'Sicherheitsüberprüfung',
		enterPassword: 'Geben Sie Ihr Passwort ein',
		invalidPassword: 'Ungültiges Passwort. Bitte versuchen Sie es erneut.',
		verificationError: 'Passwort kann nicht überprüft werden. Bitte versuchen Sie es später erneut.',
		disclaimerConfirmation: 'Ich habe die Auswirkungen dieser Aktion gelesen und verstanden',
		// General
		whatHappens: 'Was passiert als Nächstes?',
		disclaimer: 'Wichtiger Hinweis',
		hint: 'Tipp',
	},
}
